import { Box, styled } from "@mui/material"
import { AsideSectionAreas } from "../AsideSection"

export const AsideSectionContentArea = styled(Box)(() => ({
  gridArea: AsideSectionAreas.content,
}))
